module.exports = __webpack_public_path__ + "img/reduce.f8514ec3.png";